import React, { memo, useCallback, useEffect } from 'react';
import { Field, useForm, useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import CommonButton from '../../../components/common-button/CommonButton';
import UploadFile from '../../project-create/components/UploadFile';
import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';
import ActionsSection from '../actions-sections/ActionsSection';

import scss from './FileSection.module.scss';

const FileFormInner = ({ onSubmit }) => {
  const { t } = useTranslation('projects');
  const editProject = useSelector((state) => state.projects.editProject);
  const isFileSectionLoading = useSelector((state) => state.projects.isFileSectionLoading);

  const { restart } = useForm();
  const { dirty, valid } = useFormState();

  const handleDiscardsChanges = useCallback(() => {
    restart();
  }, [restart]);

  const handleSubmit = useCallback(() => {
    onSubmit();
  }, [onSubmit]);

  return (
    <div className={scss.form}>
      <Field name='file' type='file'>
        {({ input }) => (
          <UploadFile
            onChange={input.onChange}
            onFocus={input.onFocus}
            onBlur={input.onBlur}
            name={input.name}
            value={input.value}
            defaultFileName={editProject?.fileName}
            maxWidth={360}
            disabled={!editProject || isFileSectionLoading}
            customButton={(props) => (
              <CommonButton styleColor='secondary' {...props}>
                <Icon icon={ICONS.SaveFile} />
                {t('changeFile')}
              </CommonButton>
            )}
          />
        )}
      </Field>

      <ActionsSection
        dirty={dirty}
        valid={valid}
        onDiscard={handleDiscardsChanges}
        onSubmit={handleSubmit}
        isLoading={isFileSectionLoading}
      />
    </div>
  );
};

export default memo(FileFormInner);
